let isInit = false;
let listeners = [];

const Categories = {
    StrictlyNecessary: 'C0001',
    Performance: 'C0002',
    Functional: 'C0003',
    Targeting: 'C0004',
    SocialMedia: 'C0005',
};

const areCookiesAccepted = (activeGroups, testGroups) => new RegExp(testGroups.join("|")).test(activeGroups);

const handleOnChange = ({ detail }) => {
    let { isBannerClosed, activeGroups } = detail;
    listeners.map(({ callback, groups }) => callback(isBannerClosed && areCookiesAccepted(activeGroups, groups)));
};

/* eslint-disable-next-line no-undef */
const init = () => window.addEventListener('cookieCompliance:onChange', handleOnChange);

const CookieCompliance = (callback, groups) => {
    // istanbul ignore next
    if (!isInit) init();
    listeners.push({ callback, groups: Array.isArray(groups) ? groups : [groups] });
    /* eslint-disable-next-line no-undef */
    window.dispatchEvent(new CustomEvent('cookieCompliance:getData'));
};

export { CookieCompliance, Categories as CookieComplianceCategories };
